import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styles from './BookingLocation.scss';
import { locationApi } from '~/api';
import { BookingContext, bookingClassNameModifier } from '../booking.context';
import { MapImage } from './map-image';

export class BookingLocation extends PureComponent {
  state = {
    mapImage: undefined,
  };

  componentDidMount() {
    const {
      shop: {
        address: {
          location: { latitude, longitude },
        },
      },
      width,
      height,
    } = this.props;

    locationApi
      .getMapImage({
        latitude,
        longitude,
        width,
        height,
      })
      .then((image) => {
        this.setState({ mapImage: image });
      });
  }

  render() {
    const {
      shop: {
        name,
        address: { addressLines, searchTerm },
      },
      locationAdditionalInformation,
    } = this.props;
    const { mapImage } = this.state;
    return (
      <BookingContext.Consumer>
        {(context) => (
          <div
            className={`${styles[`${bookingClassNameModifier(context)}BookingReview__location`]} sessioncamhidemap`}
            data-testid="appointmentLocation"
          >
            <MapImage imageSrc={mapImage} searchQuery={`${name} ${searchTerm}`} />
            <div>
              <h5>{name}</h5>
              <address>{addressLines}</address>
              {locationAdditionalInformation ? <p>{locationAdditionalInformation}</p> : null}
            </div>
          </div>
        )}
      </BookingContext.Consumer>
    );
  }
}
BookingLocation.propTypes = {
  shop: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.shape({
      addressLines: PropTypes.string.isRequired,
      searchTerm: PropTypes.string.isRequired,
      location: PropTypes.shape({
        latitude: PropTypes.number.isRequired,
        longitude: PropTypes.number.isRequired,
      }),
    }),
  }).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  locationAdditionalInformation: PropTypes.string,
};

BookingLocation.defaultProps = {
  width: 400,
  height: 400,
  locationAdditionalInformation: null,
};
